import { render, staticRenderFns } from "./ProAppointmentsBPage.vue?vue&type=template&id=f06a0742"
import script from "./ProAppointmentsBPage.vue?vue&type=script&lang=js"
export * from "./ProAppointmentsBPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports